import { makeStyles } from '@fluentui/react-components';

export const useStyles = makeStyles({
    tableCellSpanAllMinusOne: {
        gridColumn: '1 / -2',
    },
});
